import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/lenis";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import { Workshops, Consulting } from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import WhyUs from "@/components/WhyUs";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

const HomePage = () => (
  <>
    <Navigation />
    <main>
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Workshops />
      <Consulting />
      <WhyUs />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="bg-white text-ink antialiased overflow-x-clip">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
